import { LINE_ANNOTATION_AREA_CHART, LINE_ANNOTATION_AVG, LINE_ANNOTATION_DIVIDENDS, LINE_ANNOTATION_EARNINGS_RESULTS, LINE_ANNOTATION_FORCE_ORIGINAL, LINE_ANNOTATION_FORCE_SINGLE_PANEL, LINE_ANNOTATION_HIDDEN, LINE_ANNOTATION_LINE_COLOR, LINE_ANNOTATION_LINE_WEIGHT, LINE_ANNOTATION_MAX, LINE_ANNOTATION_MIN, LINE_ANNOTATION_SPINOFFS, LINE_ANNOTATION_SPLITS, } from 'ChartApp/ts/features/fund-chart-page-shared/components/fund-chart-correlations/fund-chart-correlations.constants';
export var FundChartOptionValue;
(function (FundChartOptionValue) {
    FundChartOptionValue["SHOW_CUSTOM_COLORS"] = "useCustomColors";
    FundChartOptionValue["SHOW_FORWARD_ESTIMATES"] = "useEstimates";
    FundChartOptionValue["SHOW_UNITS_IN_LEGEND"] = "units";
    FundChartOptionValue["SHOW_US_RECESSIONS"] = "recessions";
    FundChartOptionValue["USE_LOG_SCALE"] = "scaleType";
    FundChartOptionValue["DATA_IN_LEGEND"] = "dataInLegend";
    FundChartOptionValue["NAME_IN_LEGEND"] = "nameInLegend";
    FundChartOptionValue["HIDE_VALUE_FLAGS"] = "hideValueFlags";
})(FundChartOptionValue || (FundChartOptionValue = {}));
export var FundChartSeriesType;
(function (FundChartSeriesType) {
    FundChartSeriesType["security"] = "security";
    FundChartSeriesType["securityList"] = "security_list";
})(FundChartSeriesType || (FundChartSeriesType = {}));
export var CorrelationType;
(function (CorrelationType) {
    CorrelationType["RATIO"] = "ratio";
    CorrelationType["SPREAD"] = "spread";
    CorrelationType["CORRELATION"] = "correlation";
})(CorrelationType || (CorrelationType = {}));
export var CorrelationSecurityType;
(function (CorrelationSecurityType) {
    CorrelationSecurityType["FIXED"] = "fixed";
    CorrelationSecurityType["FIRST"] = "first";
    CorrelationSecurityType["LIST"] = "list";
})(CorrelationSecurityType || (CorrelationSecurityType = {}));
